import {
  Box,
  Fade,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";

import Header from "../Header";
import SectionLayout from "../../layouts/SectionLayout";
import SlideTransition from "../SlideTransition";

import useContent from "../../hooks/useContent";
import useInView from "../../hooks/useInView";
import { theme } from "../../utils/theme";

import { styles } from "./style";

const Ecosystem = () => {
  const content = useContent();
  const [setRef, visible] = useInView({
    threshold: 0.1,
  });
  const matches = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <SectionLayout
      style={{
        backgroundColor: theme.palette.primary.light,
        height: "fit-content",
        width: "100%",
      }}
    >
      <Stack ref={setRef} spacing={12} width={"100%"}>
        <SlideTransition appear={visible} timeout={800}>
          <Stack spacing={4} width={"100%"}>
            <Header
              center={true}
              // color={"white"}
              data={content.ecosystem}
              decorationPos={"bottom"}
            />
            <Typography sx={styles.bodyText}>
              {content.ecosystem.body}
            </Typography>
          </Stack>
        </SlideTransition>

        <Grid container direction={"row"} spacing={0} sx={styles.body}>
          {content.ecosystem?.items.map((item, index) => {
            return (
              <Grid item key={index} xs={12} sm={6} md={3}>
                <Stack spacing={6} sx={styles.item}>
                  {/* Image */}
                  <Box sx={styles.imageContainer}>
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        width: "177%",
                        transition: "transform 0.5s ease-in-out",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.1)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    />
                  </Box>

                  <Fade in={visible} timeout={900 + index}>
                    <Stack spacing={2} sx={{ alignItems: "center" }}>
                      <Typography sx={styles.itemHeader}>
                        {item.title}
                      </Typography>

                      <Typography sx={styles.itemText}>{item.text}</Typography>
                    </Stack>
                  </Fade>
                </Stack>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </SectionLayout>
  );
};

export default Ecosystem;
